export enum TransactionDirection {
  In = "IN",
  Out = "OUT",
}
